"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const HBIcon_1 = __importDefault(require("../components/HBIcon/HBIcon"));
function CalendarClock16Svg(props) {
    return react_1.default.createElement("svg", Object.assign({ width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 1H3V3H1V15H7V13H3V5H7H13H15V3H13V1H11V3H5V1ZM6 9V11H4V9H6ZM6 8V6H4V8H6ZM7 6H9V6.75777C9.71505 6.27914 10.5749 6 11.5 6C13.9853 6 16 8.01472 16 10.5C16 12.9853 13.9853 15 11.5 15C9.01472 15 7 12.9853 7 10.5C7 9.57493 7.27914 8.71505 7.75777 8H7V6ZM14.3 10.5C14.3 12.0464 13.0464 13.3 11.5 13.3C9.9536 13.3 8.7 12.0464 8.7 10.5C8.7 8.9536 9.9536 7.7 11.5 7.7C13.0464 7.7 14.3 8.9536 14.3 10.5ZM12.8546 11.5733L12.001 10.7444L12.0076 9.0038L11.0076 9L11.0001 10.9609L11 10.961L10.9959 10.9959L10.9671 11.2366L12.1068 12.3434L12.8546 11.5733Z", fill: "#383F49" }));
}
function CalendarClock16(_a) {
    var { svgProps } = _a, props = __rest(_a, ["svgProps"]);
    return react_1.default.createElement(HBIcon_1.default, Object.assign({}, props),
        react_1.default.createElement(CalendarClock16Svg, Object.assign({}, svgProps)));
}
exports.default = CalendarClock16;
//# sourceMappingURL=CalendarClock16.js.map